import { type CSSObject } from '@emotion/react'

export const highContrast = (args: CSSObject): CSSObject => ({
  '@media (forced-colors: active)': args,
})
